// Spinner verbs, original 187 list from Claude Code's spinnerVerbs.txt,
// plus a hand-rolled Russian first-person playful translation. Each spin we
// pick a random ~8 of them and rotate, so the user never sees the same
// "thinking" message twice in a row.

import { lang } from "./i18n";

export const EN_VERBS: readonly string[] = [
  "Accomplishing", "Actioning", "Actualizing", "Architecting", "Baking",
  "Beaming", "Beboppin'", "Befuddling", "Billowing", "Blanching",
  "Bloviating", "Boogieing", "Boondoggling", "Booping", "Bootstrapping",
  "Brewing", "Bunning", "Burrowing", "Calculating", "Canoodling",
  "Caramelizing", "Cascading", "Catapulting", "Cerebrating", "Channeling",
  "Choreographing", "Churning", "Clauding", "Coalescing", "Cogitating",
  "Combobulating", "Composing", "Computing", "Concocting", "Considering",
  "Contemplating", "Cooking", "Crafting", "Creating", "Crunching",
  "Crystallizing", "Cultivating", "Deciphering", "Deliberating", "Determining",
  "Dilly-dallying", "Discombobulating", "Doing", "Doodling", "Drizzling",
  "Ebbing", "Effecting", "Elucidating", "Embellishing", "Enchanting",
  "Envisioning", "Evaporating", "Fermenting", "Fiddle-faddling", "Finagling",
  "Flambéing", "Flibbertigibbeting", "Flowing", "Flummoxing", "Fluttering",
  "Forging", "Forming", "Frolicking", "Frosting", "Gallivanting",
  "Galloping", "Garnishing", "Generating", "Gesticulating", "Germinating",
  "Gitifying", "Grooving", "Gusting", "Harmonizing", "Hashing",
  "Hatching", "Herding", "Honking", "Hullaballooing", "Hyperspacing",
  "Ideating", "Imagining", "Improvising", "Incubating", "Inferring",
  "Infusing", "Ionizing", "Jitterbugging", "Julienning", "Kneading",
  "Leavening", "Levitating", "Lollygagging", "Manifesting", "Marinating",
  "Meandering", "Metamorphosing", "Misting", "Moonwalking", "Moseying",
  "Mulling", "Mustering", "Musing", "Nebulizing", "Nesting",
  "Newspapering", "Noodling", "Nucleating", "Orbiting", "Orchestrating",
  "Osmosing", "Perambulating", "Percolating", "Perusing", "Philosophising",
  "Photosynthesizing", "Pollinating", "Pondering", "Pontificating", "Pouncing",
  "Precipitating", "Prestidigitating", "Processing", "Proofing", "Propagating",
  "Puttering", "Puzzling", "Quantumizing", "Razzle-dazzling", "Razzmatazzing",
  "Recombobulating", "Reticulating", "Roosting", "Ruminating", "Sautéing",
  "Scampering", "Schlepping", "Scurrying", "Seasoning", "Shenaniganing",
  "Shimmying", "Simmering", "Skedaddling", "Sketching", "Slithering",
  "Smooshing", "Sock-hopping", "Spelunking", "Spinning", "Sprouting",
  "Stewing", "Sublimating", "Swirling", "Swooping", "Symbioting",
  "Synthesizing", "Tempering", "Thinking", "Thundering", "Tinkering",
  "Tomfoolering", "Topsy-turvying", "Transfiguring", "Transmuting", "Twisting",
  "Undulating", "Unfurling", "Unravelling", "Vibing", "Waddling",
  "Wandering", "Warping", "Whatchamacalliting", "Whirlpooling", "Whirring",
  "Whisking", "Wibbling", "Working", "Wrangling", "Zesting",
  "Zigzagging",
];

/**
 * Russian translations. First-person present singular, playful, sometimes
 * absurd, we lean into the made-up gerunds of the original where they fit
 * the slot-machine energy. Each one is followed by "…" at render time.
 */
export const RU_VERBS: readonly string[] = [
  "Свершаю", "Действую", "Воплощаю", "Архитекторю", "Запекаю",
  "Сияю", "Бибопю", "Дурачу", "Клубчусь", "Бланширую",
  "Разглагольствую", "Буги-вугую", "Бездельничаю с пользой", "Бупаю", "Бутстрапю",
  "Завариваю", "Булочкаю", "Норьюсь", "Вычисляю", "Обнимашничаю",
  "Карамелизую", "Каскадирую", "Катапультирую", "Шевелю извилинами", "Каналирую",
  "Хореографирую", "Сбиваю", "Клавдирую", "Срастаюсь", "Соображаю",
  "Комбобулирую", "Сочиняю", "Считаю", "Стряпаю", "Размышляю",
  "Созерцаю", "Готовлю", "Мастерю", "Творю", "Хрущу",
  "Кристаллизую", "Возделываю", "Расшифровываю", "Прикидываю", "Определяю",
  "Дилитайдалюсь", "Дискомбобулирую", "Делаю", "Карябаю", "Капаю",
  "Отливаю", "Эффектирую", "Проясняю", "Приукрашиваю", "Очаровываю",
  "Воображаю", "Испаряюсь", "Ферментирую", "Финтифлюшничаю", "Финагливаю",
  "Фламбирую", "Флибертижиббечу", "Теку", "Озадачиваю", "Трепещу",
  "Кую", "Формирую", "Резвлюсь", "Покрываю глазурью", "Шатаюсь",
  "Скачу", "Гарнирую", "Генерирую", "Жестикулирую", "Прорастаю",
  "Гитифицирую", "Грувю", "Порывисто дую", "Гармонизирую", "Хеширую",
  "Высиживаю", "Пасу", "Сигналю", "Шумерю", "Гиперпространствую",
  "Идеирую", "Воображаю", "Импровизирую", "Инкубирую", "Вывожу",
  "Настаиваю", "Ионизирую", "Джиттербагую", "Жульеню", "Месю",
  "Подкисляю", "Левитирую", "Лоботрясничаю", "Манифестирую", "Маринуюсь",
  "Меандрирую", "Метаморфозюсь", "Мглюсь", "Лунной походкой", "Прогуливаюсь",
  "Обдумываю", "Собираюсь с мыслями", "Мечтаю", "Распыляю", "Гнездюсь",
  "Газетничаю", "Импровизирую на струнах", "Зарождаюсь", "Орбитирую", "Оркеструю",
  "Осмосю", "Прогуливаюсь", "Перколирую", "Просматриваю", "Философствую",
  "Фотосинтезирую", "Опыляю", "Размышляю", "Понтуюсь", "Подкрадываюсь",
  "Выпадаю осадком", "Фокусничаю", "Обрабатываю", "Расстаиваюсь", "Распространяюсь",
  "Копаюсь", "Складываю пазл", "Квантизирую", "Эпатирую", "Дразматазирую",
  "Перекомбобулирую", "Сплетаюсь", "Гнездюсь на ночёвку", "Жую жвачку мыслей", "Пассерую",
  "Шныряю", "Волочусь", "Юркаю", "Приправляю", "Шенаниганю",
  "Шимми трясу", "Томлю", "Удираю", "Набрасываю", "Скольжу",
  "Сминаю", "Сок-хопаю", "Спелеологирую", "Кручу", "Прорастаю",
  "Тушу", "Сублимирую", "Вихряюсь", "Пикирую", "Симбиозирую",
  "Синтезирую", "Темперирую", "Думаю", "Громыхаю", "Колдую с шестерёнками",
  "Дурачусь", "Кверх тормашкаюсь", "Преображаюсь", "Превращаюсь", "Кручу",
  "Извиваюсь", "Разворачиваюсь", "Распутываю", "Вайбюсь", "Переваливаюсь",
  "Странствую", "Деформирую", "Хренотенюсь", "Водоворочусь", "Жужжу",
  "Взбиваю", "Виблюсь", "Работаю", "Укрощаю", "Цедрюсь",
  "Зигзагирую",
];

if (EN_VERBS.length !== RU_VERBS.length) {
  // Defensive, keeps the dev honest if either list drifts.
  console.warn("verb list length mismatch", EN_VERBS.length, RU_VERBS.length);
}

/** Pull a fresh, shuffled set of N verbs in the current locale. */
export function pickVerbs(n = 8): string[] {
  const pool = lang() === "ru" ? RU_VERBS : EN_VERBS;
  // Reservoir-style shuffle of just the first N, cheap on a 187-item array.
  const indices = Array.from({ length: pool.length }, (_, i) => i);
  for (let i = pool.length - 1; i > pool.length - 1 - n && i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [indices[i], indices[j]] = [indices[j], indices[i]];
  }
  return indices.slice(-n).map((i) => pool[i]);
}
